/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.25/esri/copyright.txt for details.
*/
const e="20221121",f="f520630575ed53cf8b49e5f1492799065ee366e5";export{e as buildDate,f as commitHash};
